module.exports = __webpack_public_path__ + "img/ball_6_green.714e0edb.png";